/*
  PLP auto-contrast for overlays on product card images.
  Samples the brightness of the image under the badge (top-left), wishlist heart (top-right)
  and quick-add button (bottom-right) and sets on the card:
    data-tone-badge / data-tone-wish / data-tone-qa = 'light' (light image -> dark icon) | 'dark' (keep white)
    data-busy-badge / data-busy-wish / data-busy-qa  = present when the area is busy (adds a soft halo)
  Re-evaluates when the visible image changes (load, hover, swatch click, mobile swipe, new cards).
  Also supports the Model/Studio toggle (html.plp-view--studio, [data-studio-image]) if that is added later.
*/
(function () {
  if (window.__plpContrast) return;
  window.__plpContrast = true;

  var root = document.documentElement;
  /* Relative luminance where white and #212121 text give equal contrast is ~0.21. */
  var THRESHOLD = 0.24;
  /* Std-dev of luminance above which the background counts as busy. */
  var BUSY = 0.12;
  var SAMPLE_W = 64;
  var thumbs = new Map(); /* src -> { w, h, lum } downsampled luminance map */

  function lin(c) {
    c = c / 255;
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }

  function isTouch() {
    return root.classList.contains('supports-touch');
  }

  /* Which <img> is currently showing in this card? */
  function visibleImage(card) {
    var box = card.querySelector('.product-item__image');
    if (!box) return null;
    var studioMode = root.classList.contains('plp-view--studio');
    var studio = card.querySelector('[data-studio-image] img');
    var base = card.querySelector('.product-item__bg > figure img');
    var slider = card.querySelector('[data-hover-slider]');

    if (isTouch()) {
      if (slider && slider.clientWidth) {
        var idx = Math.round(slider.scrollLeft / slider.clientWidth);
        var slide = slider.querySelectorAll('.product-item__bg__slide')[idx];
        var img = slide && slide.querySelector('img');
        if (img) return img;
      }
      return base;
    }

    var hovered = box.matches(':hover');
    if (studioMode && studio) return hovered ? base : studio;
    if (hovered && slider) {
      var sel = slider.querySelector('.is-selected img') || slider.querySelector('[data-hover-slide] img');
      if (sel) return sel;
    }
    return base;
  }

  /* Downsample the whole image once into a small luminance grid (avoids srcset/density pixel mismatches). */
  function thumb(img) {
    if (!img || !img.complete || !img.naturalWidth) return null;
    var src = img.currentSrc || img.src;
    if (thumbs.has(src)) return thumbs.get(src);
    var w = SAMPLE_W;
    var h = Math.max(1, Math.round((SAMPLE_W * img.naturalHeight) / img.naturalWidth));
    try {
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data;
      var lum = new Float32Array(w * h);
      var opaque = 0;
      for (var i = 0, p = 0; i < d.length; i += 4, p++) {
        lum[p] = 0.2126 * lin(d[i]) + 0.7152 * lin(d[i + 1]) + 0.0722 * lin(d[i + 2]);
        if (d[i + 3] > 0) opaque++;
      }
      if (!opaque) return null; /* not decoded yet */
      var t = { w: w, h: h, lum: lum };
      thumbs.set(src, t);
      return t;
    } catch (e) {
      return null; /* cross-origin image: leave theme default */
    }
  }

  /* Mean and std-dev of luminance under an overlay element, honouring object-fit: cover. */
  function statsUnder(el, img, box) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    var b = box.getBoundingClientRect();
    if (!r.width || !b.width) return null;
    var t = thumb(img);
    if (!t) return null;
    var pad = 4;
    var scale = Math.max(b.width / t.w, b.height / t.h);
    var offX = (b.width - t.w * scale) / 2, offY = (b.height - t.h * scale) / 2;
    var x0 = Math.floor((r.left - pad - b.left - offX) / scale), x1 = Math.ceil((r.right + pad - b.left - offX) / scale);
    var y0 = Math.floor((r.top - pad - b.top - offY) / scale), y1 = Math.ceil((r.bottom + pad - b.top - offY) / scale);
    x0 = Math.max(0, x0); y0 = Math.max(0, y0); x1 = Math.min(t.w, x1); y1 = Math.min(t.h, y1);
    var sum = 0, sq = 0, n = 0;
    for (var y = y0; y < y1; y++) {
      for (var x = x0; x < x1; x++) { var v = t.lum[y * t.w + x]; sum += v; sq += v * v; n++; }
    }
    if (!n) return null;
    var mean = sum / n;
    return { mean: mean, sd: Math.sqrt(Math.max(0, sq / n - mean * mean)) };
  }

  function apply(card, name, s) {
    if (!s) return;
    var tone = s.mean > THRESHOLD ? 'light' : 'dark';
    if (card.getAttribute('data-tone-' + name) !== tone) card.setAttribute('data-tone-' + name, tone);
    var busy = s.sd > BUSY;
    if (busy !== card.hasAttribute('data-busy-' + name)) card.toggleAttribute('data-busy-' + name, busy);
  }

  function update(card) {
    var box = card.querySelector('.product-item__image');
    var img = visibleImage(card);
    if (!box || !img) return;
    apply(card, 'badge', statsUnder(card.querySelector('.badge-box-container .badge-box'), img, box));
    apply(card, 'wish', statsUnder(card.querySelector('button.wk-button') || card.querySelector('wk-icon'), img, box));
    apply(card, 'qa', statsUnder(card.querySelector('.product-item__image .quick-add__button'), img, box));
  }

  function updateAll() {
    var cards = document.querySelectorAll('grid-item.product-item');
    for (var i = 0; i < cards.length; i++) update(cards[i]);
  }

  function cardOf(el) {
    return el && el.closest ? el.closest('grid-item.product-item') : null;
  }

  /* Image finished loading (lazy images, swatch swaps). */
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') {
      var c = cardOf(e.target);
      if (c) update(c);
    }
  }, true);

  /* Desktop hover swaps the visible image. */
  ['pointerover', 'pointerout'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var c = cardOf(e.target);
      if (!c) return;
      var rel = cardOf(e.relatedTarget);
      if (rel === c) return;
      setTimeout(function () { update(c); }, 30);
    });
  });

  /* Mobile swipe slider. */
  var scrollTimers = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-hover-slider]')) return;
    clearTimeout(scrollTimers.get(t));
    scrollTimers.set(t, setTimeout(function () { var c = cardOf(t); if (c) update(c); }, 80));
  }, true);

  /* Colour swatch clicks swap images. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('tooltip-component');
    var c = cardOf(sw);
    if (c) setTimeout(function () { update(c); }, 60);
  });

  /* Model / Studio toggle (if present). */
  window.addEventListener('plp:view-change', function () { setTimeout(updateAll, 60); setTimeout(updateAll, 600); });
  window.addEventListener('resize', function () { clearTimeout(window.__plpContrastResize); window.__plpContrastResize = setTimeout(updateAll, 200); });

  /* New cards from filters / sorting / infinite scroll, and late-rendered wishlist buttons. */
  var pending = false;
  new MutationObserver(function (muts) {
    var added = false;
    for (var i = 0; i < muts.length && !added; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('grid-item.product-item, .wk-button, wk-icon') || n.querySelector('grid-item.product-item, .wk-button'))) { added = true; break; }
      }
    }
    if (!added || pending) return;
    pending = true;
    setTimeout(function () { pending = false; updateAll(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();
  window.addEventListener('load', updateAll);
  setTimeout(updateAll, 2000);
})();
